
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import { Auth } from "aws-amplify";
import { showNotifyDialog } from "@/lib/dialog";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField },
  data() {
    return {
      passwordOld: "",
      passwordNew: "",
      passwordNewConfirm: "",
      message: "",
      processing: false,
    };
  },
  methods: {
    async submit() {
      if (this.passwordNew !== this.passwordNewConfirm) {
        this.message = this.$t('changePasswordPage.errors.passwordMismatch') as string;
        return;
      }
      if (this.passwordNew.length < 7) {
        this.message = this.$t('changePasswordPage.errors.newPasswordTooShort') as string;
        return;
      }
      if (this.passwordOld.length < 7) {
        this.message = this.$t('changePasswordPage.errors.currentPasswordTooShort') as string;
        return;
      }

      this.processing = true;
      try {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.changePassword(user, this.passwordOld, this.passwordNew);
        this.message = "";
        await showNotifyDialog({ content: this.$t('changePasswordPage.successMessage') as string });
        this.$router.push({ name: "myPage" });
      } catch (error: any) {
        console.error(error);
        const { code } = error;
        if (code === "NotAuthorizedException") {
          this.message = this.$t('changePasswordPage.errors.incorrectPassword') as string;
          this.passwordOld = "";
        } else if (code === "InvalidPasswordException") {
          this.message = this.$t('changePasswordPage.errors.invalidPassword') as string;
        } else if (code === "LimitExceededException") {
          this.message = this.$t('changePasswordPage.errors.limitExceeded') as string;
        } else if (code === "NetworkError") {
          this.message = this.$t('changePasswordPage.errors.networkError') as string;
        } else {
          this.message = `${this.$t('changePasswordPage.errors.genericError')}${error.message || error}`;
        }
      } finally {
        this.processing = false;
      }
    },
  },
});
